import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_right",
  "use": "icon-ic_right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ic_right\">\n<path d=\"M18.1716 11.0003L2 11.0003V13.0003L18.1716 13.0003L11.3934 19.7784L12.8076 21.1926L21.6464 12.3538C21.8417 12.1586 21.8417 11.842 21.6464 11.6467L12.8076 2.80786L11.3934 4.22207L18.1716 11.0003Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol